import React from "react";
import { Link } from "react-router-dom";

const SubscriptionExpired: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="max-w-3xl bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center animate-fadeIn">
        <h1 className="text-6xl md:text-7xl font-extrabold text-red-600 animate-bounce">
          ⚠️
        </h1>
        <h2 className="text-3xl md:text-4xl text-gray-800 mt-4">
          Subscription Expired
        </h2>
        <p className="text-gray-600 mt-2">
          Your subscription has expired. To continue using Wiventory, please renew your plan.
        </p>
        <div className="mt-6 flex justify-center gap-4">
          <Link
            to="/renew-subscription"
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform duration-300 shadow-md"
          >
            Renew Subscription
          </Link>
          <Link
            to="/login"
            className="px-6 py-3 bg-gray-300 rounded-lg hover:bg-gray-400 hover:scale-105 transition-transform duration-300 shadow-md"
          >
            Back to Login
          </Link>
        </div>
      </div>

      {/* Tailwind Animations */}
      <style>
        {`
          @keyframes fadeIn {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.8s ease-out forwards;
          }

          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          .animate-bounce {
            animation: bounce 1.5s infinite;
          }
        `}
      </style>
    </div>
  );
};

export default SubscriptionExpired;
